
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { EnrollDeviceDialog } from "@/components/device/EnrollDeviceDialog";

export const DashboardHeader = () => {
  const [isEnrollDialogOpen, setIsEnrollDialogOpen] = useState(false);

  return (
    <div className="flex justify-between items-start mb-8">
      <div className="text-left">
        <h1 className="text-2xl font-bold text-slate-900 dark:text-white">Devices</h1>
        <p className="text-sm text-slate-500 dark:text-slate-400 mt-2">
          Monitor and manage your enrolled devices
        </p>
      </div>
      <Button 
        onClick={() => setIsEnrollDialogOpen(true)}
      >
        <Plus className="mr-2 h-4 w-4" />
        Enroll Device
      </Button>

      <EnrollDeviceDialog 
        isOpen={isEnrollDialogOpen}
        onClose={() => setIsEnrollDialogOpen(false)}
      />
    </div>
  );
};
